import { createValidator, requiredRichText, richTextMaxLength } from 'util/validation'

import { PlanoFormModel } from '../PlanoForm'
import { intervencoesProcedimentosValidator } from './validator-procedimentos'

export const planoObservacaoValidator = () =>
  createValidator<PlanoFormModel>({
    texto: [requiredRichText, richTextMaxLength(4000)],
    intervencoesProcedimentos: intervencoesProcedimentosValidator,
  })
